import React, { useState } from "react";
import axios from "axios";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
// config
import configData from "../../../config/config.json";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#33e0a0" : "#33e0a0",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 18,
    height: 18,
  },
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

function ActiveSwitch(props) {
  const { data, setData, setDataCome } = props;

  const [centredModal, setCentredModal] = useState(false);
  const toggleShow = () => setCentredModal(!centredModal);

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const switchHandler = (event) => {
    setCentredModal(true);
  };

  const submitHandler = (event) => {
    const dataPost = {
      bId: getCookie("BizId"),
      // isDisable: event.target.checked,
      isDisable: !data.IsDisable,
    };

    axios
      .patch(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/status`,
        dataPost,
        {
          headers: header,
        }
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toggleShow();

          // success
          axios
            .get(
              configData.API_DOMAIN +
                `/api/v1/Businesses/${getCookie("BizUuid")}`,
              {
                headers: header,
              }
            )
            .then((response) => {
              if (response.data.isSuccess) {
                let data = response.data.data;
                setData({
                  EnTitle: data.enTitle,
                  ApproveStatus: data.approveStatus,
                  IsApprove: data.isApproved,
                  IsDisable: data.isDisable,
                  Photo: data.photoPath,
                });
              }
            })
            .catch((error) => {
              // alert(error);
            });
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      <div className="mt-n2 mt-md-5">
        <span className="span_part_one">
          کسب‌وکار {data.IsDisable ? "غیرفعال" : "فعال"} است:
        </span>
        <FormControlLabel
          control={
            <IOSSwitch
              sx={{ m: 0.5 }}
              checked={!data.IsDisable}
              onChange={switchHandler}
            />
          }
          className="me-2"
        />
      </div>
      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog centered>
          <MDBModalContent className={"modal_delete_img height-fit"}>
            <MDBModalHeader className="modal-delete-img-header">
              <MDBModalTitle></MDBModalTitle>
              <MDBBtn
                className="btn-close button_delete_modal_img"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div>
                <p
                  className={"text_modal_delete_img text_modal_delete_img_pre"}
                >
                  {/* برای ثبت کسب‌و‌کارهای بیشتر نیاز به خرید اشتراک پریمیوم
                    دارید! */}
                  آیا از {!data.IsDisable ? "غیرفعال" : "فعال"} کردن کسب‌و‌کار
                  خود مطمئن هستید؟
                </p>
              </div>
              <div className="a_s_c d-flex justify-content-center">
                <button
                  // onClick={props.api ? handleInputChangeApi : handleInputChange}
                  onClick={submitHandler}
                  className="button_modal_delete_img"
                >
                  تایید
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}

export default ActiveSwitch;
